import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import vco from 'v-click-outside'
import * as Sentry from '@sentry/vue'
import VueI18Next from '@panter/vue-i18next'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18next from '@/utils/i18next'
import VueCookies from 'vue-cookies'
import VueLazyLoad from 'vue-lazyload'

Vue.config.productionTip = false

Vue.use(VueLazyLoad)
Vue.use(BootstrapVue)
Vue.use(vco)
Vue.use(VueI18Next)
Vue.use(VueCookies)

const i18n = new VueI18Next(i18next)

if (process.env.VUE_APP_ENV !== 'ldev') {
	Sentry.init({
		Vue,
		dsn: process.env.VUE_APP_SENTRY_DSN,
		environment: process.env.VUE_APP_ENV,
		integrations: [
			new Sentry.BrowserTracing({
				tracePropagationTargets: ['localhost', /^\//],
				routingInstrumentation: Sentry.vueRouterInstrumentation(router)
			}),
			new Sentry.Replay()
		],
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 0.1,
		release: process.env.VUE_APP_VERSION,
		ignoreErrors: [
			/Redirected when going from "\\\w*" to "\\\w*" via a navigation guard./,
			/Avoided redundant navigation to current location/
		]
	})
}

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app')
